import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
  payments: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
  filters: {
    page: 1,
    limit: 10,
    search: "",
    paymentType: "",
    status: "",
    sortBy: "createdAt",
    sortOrder: "desc",
    startDate: null,
    endDate: null,
  },
};

const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPayments: (state, action) => {
      state.payments = action.payload.payments;
      state.pagination = action.payload.pagination;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setLoading, setPayments, setError, setFilter, resetFilters } =
  paymentsSlice.actions;

export const fetchPayments = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const { filters } = getState().payments;
    
    // Create a new object with only the non-null values
    const params = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});

    const response = await axiosInstance.get("/payments/list", { params });
    dispatch(
      setPayments({
        payments: response.data.data.payments,
        pagination: response.data.data.pagination,
      })
    );
  } catch (error) {
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export default paymentsSlice.reducer;